import { Badge } from "@mantine/core";
import {
  TAG_OBJECT_TYPE_COLORS,
  TAG_STATUS,
  TagObjectType,
} from "../../../model/TblDmTag";

export const StatusBadge = ({ status }: { status: string | null }) => {
  const active = status !== TAG_STATUS.inactive;
  return (
    <Badge variant="light" radius="sm" color={active ? "teal" : "red"}>
      {active ? "Đang sử dụng" : "Dừng sử dụng"}
    </Badge>
  );
};

export const ObjectTypeBadge = ({
  type,
  objectTypes,
}: {
  type: string | null;
  objectTypes: TagObjectType[];
}) => {
  if (!type) return null;
  const name = objectTypes.find((x) => x.code === type)?.name ?? type;
  return (
    <Badge
      variant="dot"
      radius="sm"
      color={TAG_OBJECT_TYPE_COLORS[type] ?? "gray"}
      tt="none"
      c="dark"
    >
      {name}
    </Badge>
  );
};

export const TagBadge = ({
  name,
  color,
}: {
  name: string;
  color: string | null;
}) => (
  <Badge variant="light" radius="xl" color={color || "blue"} tt="none">
    {name}
  </Badge>
);
